/* eslint-disable
    func-names,
    no-alert,
    no-param-reassign,
    no-restricted-globals,
    no-underscore-dangle,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const deps = [require('vendor/lodash').name];

// place on a form to throw and alert when the user tries to navigate
// while the form is dirty
// e.g. <form bl-alert-dirty="My Awesome Form"></form>

module.exports = angular
  .module('bench.ui.alertDirty', deps)

  .directive('blAlertDirty', ($rootScope, $window, _) => {
    const forms = {};
    const _dirtyForms = _(forms).filter(form => form.ctrl.$dirty);
    const _dirtyFormNames = _dirtyForms.map(form => form.name);

    const clearForms = () => _.forEach(forms, (val, key) => delete forms[key]);

    const containsDirtyForms = () => _dirtyForms.keys().value().length !== 0;

    const unloadMessage = () => `\
The following forms have been modified:

- ${_dirtyFormNames.value().join('\n- ')}\
`;
    const stateChangeMessage = () =>
      `${unloadMessage()}\n\nAre you sure you wish to proceed? (All changes will be lost)`;

    // prevent reloads and page closures
    $($window).on('beforeunload', () => {
      if (containsDirtyForms()) {
        return unloadMessage();
      }
    });

    // prevent navication within ui-router
    $rootScope.$on('$stateChangeStart', e => {
      if (containsDirtyForms() && !confirm(stateChangeMessage())) {
        e.preventDefault();
        return $rootScope.$emit('$stateChangeError');
      }
    });

    // Hack to allow this function to be called in main-app
    ($window.rind = $window.rind || {}).stopNavigation = function () {
      const stop = containsDirtyForms() && !confirm(stateChangeMessage());
      if (!stop) {
        clearForms();
      }
      return stop;
    };

    return {
      restrict: 'A',
      scope: false,
      require: 'form',
      link(scope, elem, attrs, form) {
        forms[form.$name] = {
          name: attrs.blAlertDirty,
          ctrl: form,
        };

        return scope.$on('$destroy', () => delete forms[form.$name]);
      },
    };
  });
